export const SET_PLAYING_VIDEO_E = "SET_PLAYING_VIDEO_E";
export const SET_PENDING_EXERCISE = "SET_PENDING_EXERCISE";
export const SET_TRENDING_EXERCISE = "SET_TRENDING_EXERCISE";
export const SET_NEXT_EXERCISES = "SET_NEXT_EXERCISES";
export const SET_EXERCISE = "SET_EXERCISE";
export const SET_TOP_FAVORITE_EXERCISE = "SET_TOP_FAVORITE_EXERCISE";
export const SET_TOP_WATCHED_EXERCISE = "SET_TOP_WATCHED_EXERCISE";
export const SET_TOP_FINISHED_EXERCISE = "SET_TOP_FINISHED_EXERCISE";
export const SET_EXERCISE_TYPES = "SET_EXERCISE_TYPES";
export const SET_FILTERED_EXERCISES = "SET_FILTERED_EXERCISES";

